interface JobFiltersProps {
  locations: string[];
  selectedLocation: string | null;
  onSelectLocation: (location: string | null) => void;
}

export default function JobFilters({ locations, selectedLocation, onSelectLocation }: JobFiltersProps) {
  if (locations.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2">
      <button
        type="button"
        onClick={() => onSelectLocation(null)}
        className={`px-3 py-1.5 rounded-full text-xs font-semibold transition-colors ${
          selectedLocation === null
            ? "bg-blue-600 text-white"
            : "bg-gray-100 text-gray-600 hover:bg-gray-200"
        }`}
      >
        All Locations
      </button>
      {locations.map((location) => (
        <button
          key={location}
          type="button"
          onClick={() => onSelectLocation(selectedLocation === location ? null : location)}
          className={`px-3 py-1.5 rounded-full text-xs font-semibold transition-colors ${
            selectedLocation === location
              ? "bg-blue-600 text-white"
              : "bg-gray-100 text-gray-600 hover:bg-gray-200"
          }`}
        >
          {location}
        </button>
      ))}
    </div>
  );
}
